import { ApiResponse, apiCall } from "./apiClient";
import { ApiSuccess } from "./baseService";
import { InvoiceCreateDto } from "../models/transportOrderInvoice/invoiceCreateDto";
import { InvoiceListItemDto, InvoiceListQueryParameters } from "../models/transportOrderInvoice/invoiceListItemDto";
import { InvoiceDetailsDto } from "../models/transportOrderInvoice/invoiceDetailsDto";
import { InvoiceRowAddDto } from "../models/transportOrderInvoice/invoiceRowAddDto";
import { InvoiceRowUpdateDto } from "../models/transportOrderInvoice/invoiceRowUpdateDto";
import { IdTitle } from "../models/common/idTitle";

export const getInvoices = (qsp: InvoiceListQueryParameters): Promise<ApiResponse<InvoiceListItemDto[]>> => {
    return apiCall<InvoiceListItemDto[]>("invoices", "GET", qsp);
};

export const getInvoice = (id: string): Promise<ApiResponse<InvoiceDetailsDto>> => {
    return apiCall<InvoiceDetailsDto>(`invoices/${id}`, "GET");
};

export const createNewInvoice = (data: InvoiceCreateDto): Promise<ApiResponse<InvoiceDetailsDto>> => {
    return apiCall<InvoiceDetailsDto>("Invoices",
        "POST",
        data);
};

export const addTransportOrdersToInvoice = (invoiceId: string, data: string[]): Promise<ApiResponse<string[]>> => {
    return apiCall<string[]>(`invoices/${invoiceId}/transportorders`,
        "PUT",
        data);
};

export const approveInvoice = (invoiceId: string, invoiceState: number): Promise<ApiResponse<ApiSuccess>> => {
    return apiCall(`Invoices/${invoiceId}/state?state=${invoiceState}`, "PUT");
};

export const sendInvoiceToIntegration = (
    invoiceId: string,
    integrationId: string
): Promise<ApiResponse<ApiSuccess>> => {
    return apiCall<ApiSuccess>(
        `invoices/${invoiceId}/send/${integrationId}`,
        "PUT"
    );
};

export const removeInvoice = (invoiceId: string): Promise<ApiResponse<void>> => {
    return apiCall<void>(`Invoices/${invoiceId}`, "DELETE");
};

export const createInvoiceRow = (data: InvoiceRowAddDto): Promise<ApiResponse<InvoiceDetailsDto>> => {
    return apiCall<InvoiceDetailsDto>("Invoices/InvoiceRow",
        "POST",
        data);
};

export const updateInvoiceRow = (invoiceRowId: string, data: InvoiceRowUpdateDto): Promise<ApiResponse<InvoiceDetailsDto>> => {
    return apiCall<InvoiceDetailsDto>(`Invoices/InvoiceRow/${invoiceRowId}`,
        "PUT",
        data);
};

export const removeInvoiceRow = (invoiceRowId: string,): Promise<ApiResponse<void>> => {
    return apiCall<void>(`Invoices/InvoiceRow/${invoiceRowId}`, "DELETE");
};

export const listIntegrations = (): Promise<ApiResponse<IdTitle[]>> => {
    return apiCall<IdTitle[]>("Invoices/integrations", "GET");
};